<template>
  <van-popup v-model="show" class="wrap_popup">
    <div :class="$style.title">
      客服对话框
      <van-icon name="cross" @click.stop="close" style="cursor: pointer;" />
    </div>
    <div :class="$style.wrap">
      <!-- 对话列表 -->
      <div
        :class="[$style.list, canSend ? $style.can_send : $style.no_send]"
        ref="list"
      >
        <div :class="$style.item" v-for="(item, index) in list" :key="index">
          <p :class="$style.time">{{ item.reply_time }}</p>
          <!-- 提问者/用户-->
          <div :class="$style.my" v-if="item.type == 2">
            <img :class="$style.head_img" :src="item.headUrl" alt="游戏头像" />
            <div :class="$style.content">
              <div v-if="index == 0">
                <span :class="$style.question">{{ qusetionType }}</span>
                <span>{{ roleInfo.game_role }}</span
                >丨
                <span>{{ roleInfo.server_name }}</span>
              </div>
              <span
                v-if="item.cotent != ''"
                v-html="formatMessage(item.content)"
              ></span>
            </div>
          </div>
          <!-- 回答者/客服 -->
          <div :class="$style.robot" v-else>
            <img :class="$style.head_img" :src="item.headUrl" alt="客服头像" />
            <div :class="$style.content">
              <span
                v-if="item.cotent != ''"
                v-html="formatMessage(item.content)"
              ></span>
            </div>
            <p :class="$style.new_info" v-if="item.new">new</p>
          </div>
        </div>
      </div>
      <!-- 发送内容 -->
      <div :class="$style.send_mes" ref="send" v-show="canSend">
        <van-field
          v-model="qusetion"
          type="textarea"
          maxlength="300"
          rows="1"
          autosize
          @focus="handleTextareFocus"
          @blur="handleTextareBlur"
        />
        <p :class="$style.send" @click="send">发送</p>
        <div v-if="showPlaceholder" :class="$style.placeholder">
          请输入问题描述，最多输入300字
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import { doResponse } from "@/http/serve";
export default {
  name: "CustomerService",
  props: {
    show: {
      //是否展示
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      canSend: false,
      qusetionType: "", //问题类型
      qId: "", //问题id
      qusetion: "", //问题
      list: [], //列表
      gameUrl: "", //游戏图片链接
      roleInfo: {}, //角色信息
      showPlaceholder: true
    };
  },
  methods: {
    handleTextareFocus() {
      this.showPlaceholder = false;
    },
    handleTextareBlur() {
      if (!this.qusetion) {
        this.showPlaceholder = true;
      }
    },
    /**
     * @description 字符串换行
     */
    formatMessage(text) {
      return text.replace(/\r\n|[\r\n]/g, "<br>");
    },
    /**
     * @description 关闭弹框
     */
    close() {
      this.qusetion = "";
      this.$emit("handlerShow");
    },
    /**
     * @description 获取提单对话详情
     * @param {array} data  - 对话信息
     * @param {object} item  - 问题信息
     */
    async getListInfo(data, item) {
      let { id, title, status } = item;
      this.qId = id;
      this.qusetionType = title;
      this.canSend = status == 1;
      let { role_info, kf_head_url, game_url, detailList } = data;
      detailList.forEach(item => {
        item.type == 2
          ? (item.headUrl = game_url)
          : (item.headUrl = kf_head_url);
      });
      this.list = detailList;
      this.gameUrl = game_url;
      this.roleInfo = role_info;
      this.setScrollTop();
    },
    /**
     * @description 发送信息
     */
    async send() {
      // 过滤掉值的前后空格
      const questionVal = this.qusetion.replace(/^\s+/, "").replace(/\s+$/, "");
      if (!questionVal) {
        this.$Toast("请输入问题描述");
        return false;
      }
      let parmas = {
        q_id: this.qId,
        content: questionVal
      };
      let res = await doResponse(parmas);
      let { rcode, data } = res;
      if (rcode != 0) return;
      this.list.push({
        ...data,
        headUrl: this.gameUrl
      });
      //回答完成，问题清空
      this.qusetion = "";
      this.canSend = false;
      this.setScrollTop();
      this.$emit("changeStatus", this.qId);
    },
    /**
     * @description 滚动条置于底部
     */
    setScrollTop() {
      this.$nextTick(() => {
        if (
          this.$refs.list &&
          this.$refs.send &&
          this.$refs.list.scrollHeight
        ) {
          let scrollTop =
            this.$refs.list.scrollHeight + this.$refs.send.offsetHeight;
          this.$refs.list.scrollTop = scrollTop;
        }
      });
    }
  }
};
</script>
<style lang="less" module>
.wrap {
  .size(100%);
  background: #fff;
  position: relative;
}
.list {
  overflow-y: scroll;
  margin-top: 15%;
  .item {
    padding: 0.23rem;
  }
}
.can_send {
  height: calc(100% - 2.3rem);
}
.no_send {
  height: calc(100% - 1.3rem);
}
.title {
  .size(100%, 1.1rem);
  position: fixed;
  top: 0;
  z-index: 999;
  background: #48d5af;
  font-size: 0.3rem;
  line-height: 1.1rem;
  text-align: center;
  color: #fff;
  :global {
    .van-icon {
      position: absolute;
      top: 0.3rem;
      right: 0.3rem;
      font-size: 0.4rem;
      color: #fff;
    }
  }
}
.time {
  .size(100%, auto);
  font-size: 0.26rem;
  color: #ababab;
  text-align: center;
  margin-bottom: 0.3rem;
}
.my,
.robot {
  display: flex;
  flex-direction: row;
  position: relative;
  .new_info {
    color: red;
    margin: 0.1rem 0 0 0.1rem;
  }
  .head_img {
    .size(1.05rem, 1.05rem);
    border-radius: 50%;
  }
  .content {
    display: inline-block;
    position: relative;
    max-width: 4.2rem;
    padding: 0.2rem;
    & > span {
      font-size: 0.3rem;
      color: #222222;
      word-break: break-word;
    }
  }
  .content:before {
    .size(0, 0);
    content: "";
    position: absolute;
    top: 0.22rem;
    border: 0.15rem solid;
  }
}
.my {
  justify-content: flex-end;
  padding-right: 1rem;
  .head_img {
    position: absolute;
    top: -0.15rem;
    right: 0;
  }
  .content {
    border-radius: 0.1rem;
    background-color: #e1e1e5;
    border: solid 0.01rem #dadada;
    margin-right: 0.2rem;
    & > div {
      margin-bottom: 0.1rem;
      span {
        font-size: 0.24rem;
        color: #222222;
      }
    }
  }
  .content:before {
    right: -0.28rem;
    border-color: transparent transparent transparent #e1e1e5;
  }
}
.question {
  font-weight: 700;
  font-size: 0.3rem;
  color: #222222;
  margin-right: 0.2rem;
}

.robot {
  justify-content: flex-start;
  .head_img {
    position: absolute;
    top: -0.15rem;
    left: 0;
  }
  .content {
    box-shadow: 0rem 0.09rem 0.16rem 0rem rgba(14, 5, 10, 0.06);
    margin-left: 1.2rem;
  }
  .content:before {
    left: -0.3rem;
    border-color: transparent #fff transparent transparent;
  }
}
.send_mes {
  .size(100%, auto);
  .flex-row;
  .flex-align-center;
  position: fixed;
  min-height: 1rem;
  max-height: 2rem;
  background: #fff;
  bottom: 0;
  border-top: solid 0.01rem #dadada;
  padding: 0.01rem 0rem;

  .placeholder {
    .size(100%);

    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    padding-left: 12px;
    color: #ccc;
    pointer-events: none;
    font-size: 0.28rem;
  }

  :global {
    .van-field__body textarea {
      min-height: 38px;
      max-height: 1.8rem;
      padding: 0.16rem 0 0 0 !important;
    }
    .van-cell {
      width: 79%;
      padding: 0.1rem 0.2rem;
    }
    .van-field--min-height .van-field__control {
      padding: 0;
    }
    .van-cell::after,
    .van-cell:not(:last-child)::after {
      border: none;
    }
  }
}
.send {
  position: fixed;
  bottom: 0.2rem;
  right: 0.2rem;
  background-color: #48d5af;
  font-size: 0.26rem;
  color: #ffffff;
  text-align: center;
  padding: 0.1rem 0.25rem;
}
</style>
